import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flight-container" }
const _hoisted_2 = { class: "flight-container__left" }
const _hoisted_3 = { class: "flight-container__flight" }
const _hoisted_4 = { class: "flight-container__button-row" }

import LinkButton from '@lmt-rpb/Atoms/LinkButton/LinkButton.vue';
import { useTemplateRef, computed } from 'vue';

type Props = {
	verticalDivider?: boolean;
	horizontalDivider?: boolean;
	withFlightDetails?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FlightContainer',
  props: {
    verticalDivider: { type: Boolean, default: true },
    horizontalDivider: { type: Boolean, default: true },
    withFlightDetails: { type: Boolean, default: true }
  },
  emits: ['show-flight-details'],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "5bcd7507": (rightContainerDisplay.value),
  "52928524": (leftContainerSpan.value)
}))



const emit = __emit;

const rightContainer = useTemplateRef('right');
const rightContainerDisplay = computed(() => {
	return rightContainer.value?.children.length === 0 ? 'none' : 'block';
});

const leftContainerSpan = computed(() => {
	return rightContainer.value?.children.length === 0 ? 'span 2 / span 2' : 'span 1 / span 1';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header"),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "outbound"),
        _renderSlot(_ctx.$slots, "inbound")
      ]),
      (_ctx.withFlightDetails)
        ? (_openBlock(), _createBlock(LinkButton, {
            key: 0,
            class: "flight-container__flight-details",
            label: "Flugdetails",
            as: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('show-flight-details')))
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", {
      ref: "right",
      class: _normalizeClass(['flight-container__right', { 'flight-container__right--with-divider': _ctx.verticalDivider }])
    }, [
      _renderSlot(_ctx.$slots, "right")
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(['flight-container__bottom', { 'flight-container__bottom--with-divider': _ctx.horizontalDivider }])
    }, [
      _renderSlot(_ctx.$slots, "price"),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "button")
      ])
    ], 2 /* CLASS */)
  ]))
}
}

})